import React, { useEffect, useState } from 'react';

const ChatwootWidget = ({ websiteToken, baseUrl, settings = {} }) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;
    
    // Don't load if no token provided
    if (!websiteToken || !baseUrl) {
      console.warn('Chatwoot: Missing websiteToken or baseUrl');
      return;
    }

    console.log('Chatwoot: Initializing widget...');

    // Set Chatwoot settings - hide bubble since we'll use custom button
    window.chatwootSettings = {
      hideMessageBubble: true, // Hide default bubble, use custom button instead
      position: 'right',
      locale: 'es',
      type: 'standard',
      ...settings
    };

    // Load Chatwoot script only once
    if (!window.chatwootSDK && !document.querySelector('script[src*="chatwoot"]')) {
      const script = document.createElement('script');
      script.src = `${baseUrl}/packs/js/sdk.js`;
      script.defer = true;
      script.async = true;

      script.onload = () => {
        console.log('Chatwoot: Script loaded successfully');
        if (window.chatwootSDK) {
          window.chatwootSDK.run({
            websiteToken: websiteToken,
            baseUrl: baseUrl
          });
          console.log('Chatwoot: Widget initialized');
          
          // Wait a bit for $chatwoot to be available
          setTimeout(() => {
            if (window.$chatwoot) {
              console.log('Chatwoot: Widget ready for use with custom button');
              setIsReady(true);
            }
          }, 1000);
        }
      };

      script.onerror = (error) => {
        console.error('Chatwoot: Failed to load script', error);
      };

      document.body.appendChild(script);
    } else if (window.$chatwoot) {
      // Already loaded
      setIsReady(true);
    }
  }, [websiteToken, baseUrl, settings]);

  return null;
};

export default ChatwootWidget;
